/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AssistantMemory,
  AssistantMemory$inboundSchema,
} from "./assistantmemory.js";

export type ListAssistantMemoriesResult = {
  /**
   * Assistant memories matching the query.
   */
  memories: Array<AssistantMemory>;
  /**
   * The cursor to be used for the next page of results.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListAssistantMemoriesResult$inboundSchema: z.ZodMiniType<
  ListAssistantMemoriesResult,
  unknown
> = z.pipe(
  z.object({
    memories: z.array(AssistantMemory$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listAssistantMemoriesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAssistantMemoriesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAssistantMemoriesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAssistantMemoriesResult' from JSON`,
  );
}
